/**
 * Read-only preview endpoints (RYDE-7929): how many future "New"/"Draft" bookings would move if the
 * pending station change were saved. Used to decide whether the approval popup opens at all.
 */
export const getShiftFutureBookingsImpactPath = (
  companyId: number,
  shiftId: number,
): string =>
  `/api/v1/core/c/${companyId}/shifts/${shiftId}/future-bookings-impact`;

export const getBulkShiftsFutureBookingsImpactPath = (
  companyId: number,
): string => `/api/v1/core/c/${companyId}/shifts/bulk/future-bookings-impact`;

export const getPassengerFutureBookingsImpactPath = (
  companyId: number,
  passengerId: number,
): string =>
  `/api/v1/core/c/${companyId}/passengers/${passengerId}/future-bookings-impact`;

export const getBulkPassengersFutureBookingsImpactPath = (
  companyId: number,
): string =>
  `/api/v1/core/c/${companyId}/passengers/bulk/future-bookings-impact`;
